// ============================================================
// CENTRALIZED PRICING CONFIGURATION
// Change values here ONLY. Do not hard-code prices elsewhere.
// ============================================================

export const PRICING = {
  regularPrice: 29000,
  promoPrice: 29000,
  promoEnabled: false,

  // -------------------------------------------------------------
  // PLACEHOLDER LAUNCH DATES (WAJIB DIUBAH SEBELUM PRODUCTION)
  // Promo aktif selama 3 bulan setelah peluncuran resmi.
  // Ganti nilai di bawah dengan tanggal peluncuran resmi.
  // Saat ini di-set aktif untuk keperluan demo/pengujian.
  // -------------------------------------------------------------
  promoStartDate: "2024-01-01T00:00:00+07:00",
  promoEndDate: "2027-12-31T23:59:59+07:00",
};

// Paket langganan berjenjang. `id` HARUS cocok dengan key PLANS di backend.
// price = total dibayar; months = durasi; perMonth = harga efektif per bulan.
export const PLANS = [
  {
    id: "monthly",
    label: "Bulanan",
    price: 29000,
    months: 1,
    perMonth: 29000,
    tagline: "Harga utama",
    highlight: false,
  },
  {
    id: "sixmonth",
    label: "6 Bulan",
    price: 147000,
    months: 6,
    perMonth: 24500,
    tagline: "Hemat 15%",
    highlight: true,
  },
  {
    id: "annual",
    label: "Tahunan",
    price: 236000,
    months: 12,
    perMonth: 19667,
    tagline: "Paling hemat 32%",
    highlight: false,
  },
];

export function getPricing(now = new Date()) {
  const start = new Date(PRICING.promoStartDate);
  const end = new Date(PRICING.promoEndDate);
  const isPromo =
    PRICING.promoEnabled &&
    now.getTime() >= start.getTime() &&
    now.getTime() <= end.getTime();

  return {
    isPromo,
    price: isPromo ? PRICING.promoPrice : PRICING.regularPrice,
    regularPrice: PRICING.regularPrice,
    promoPrice: PRICING.promoPrice,
    promoEndDate: end,
  };
}

// Price formatted as Rp49.000
export function formatPrice(v) {
  return "Rp" + Math.round(v).toLocaleString("id-ID");
}
